import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Button = styled.button`
  display: inline-block;
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-blue);
  color: var(--white);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background-color: var(--secondary-blue);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const Section = styled.section`
  padding: 5rem 0;
  
  &:nth-child(even) {
    background-color: var(--light-gray);
  }
`;

export const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -0.75rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background-color: var(--primary-blue);
    border-radius: 2px;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const Card = styled(motion.div)`
  background-color: var(--white);
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  
  &.center {
    justify-content: center;
    align-items: center;
  }
  
  &.space-between {
    justify-content: space-between;
  }
  
  &.column {
    flex-direction: column;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    
    &.responsive-row {
      flex-direction: row;
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--light-blue);
  color: var(--primary-blue);
  margin-bottom: 1rem;
  
  svg {
    width: 24px;
    height: 24px;
  }
`;
